import React from 'react'
import PropTypes from 'prop-types'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { StyledButton } from './components/index'

const OpsotButton = ({
	text,
	startIcon,
	endIcon = <ChevronRight />,
	onClick,
	small,
	sx,
	variant = 'contained',
	fullWidth = false,
	position = 'left',
	align = undefined,
	...props
}) => (
	<StyledButton
		sx={{ ...sx, textDecoration: variant === 'text' ? 'underline' : 'none' }}
		disableRipple
		startIcon={startIcon}
		endIcon={endIcon}
		variant={variant}
		onClick={onClick}
		fullWidth={fullWidth}
		{...(small ? { small } : {})}
		position={position}
		align={align}
		{...props}
	>
		{text}
	</StyledButton>
)

OpsotButton.propTypes = {
	text: PropTypes.string.isRequired,
	startIcon: PropTypes.node,
	endIcon: PropTypes.node,
	variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
	onClick: PropTypes.func,
	fullWidth: PropTypes.bool,
	small: PropTypes.bool,
	position: PropTypes.oneOf(['left', 'right'])
}

export default OpsotButton
